import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import classnames from 'classnames';
import { getStripeInstance } from './Stripe';
import { getCurrentLanguageCode } from '../../modules/infra/i18n/language-selection-utils/utils';

class StripeInput extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    const currentLanguage = getCurrentLanguageCode();
    this.stripe = getStripeInstance(currentLanguage);

    this.mounted = false;
    this.state = { error: '', processing: false };
    this.inputComponent = ({ className, disabled, ...inputProps }) => (
      <div ref={this.setCardEl} className={classnames(className, { 'is-disabled': disabled })} {...inputProps} />
    );
  }

  componentDidMount() {
    this.mountStripeInput();
  }

  componentWillUnmount() {
    this.unmountStripeInput();
  }

  onChange = (event) => {
    this.setState({ error: get(event, 'error.message') });
  };

  setCardEl = (el) => {
    this.cardEl = el;
  };

  createToken = async (callback) => {
    this.setState({ processing: true });
    const { token, error } = await this.stripe.createToken(this.card);

    if (error) {
      this.setState({ processing: false, error: error.message });
      return;
    }

    await callback(token);
    if (this.mounted) this.card.clear();
    this.setState({ processing: false });
  };

  mountStripeInput() {
    const isDarkScheme = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    const style = {
      base: {
        color: isDarkScheme ? '#fff' : '#1c1c1e',
        fontSize: '12px',
        fontWeight: '400',
        fontFamily: '"Open Sans", sans-serif',
        lineHeight: '40px',
        boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, .02)',

        '::placeholder': {
          color: '#8e8e93',
        },
      },
      invalid: {
        color: isDarkScheme ? '#fff' : '#1c1c1e',
        iconColor: isDarkScheme ? '#fff' : '#1c1c1e',
      },
    };
    const card = this.stripe.elements().create('card', { style });
    card.mount(this.cardEl);
    this.card = card;
    this.mounted = true;
    this.card.addListener('change', this.onChange);
  }

  unmountStripeInput() {
    this.card.removeListener('change', this.onChange);
    this.card.focus();
    this.card.blur();
    this.card.destroy();
    this.mounted = false;
  }

  render() {
    return this.props.children(this.inputComponent, this.createToken, this.state);
  }
}

export default StripeInput;
